// extracted by mini-css-extract-plugin
module.exports = {"content":"TagFilter_content__n3T24","cursorPointer":"TagFilter_cursorPointer__RrAA5"};